<!--
 * @Description:服务管理服务项目基本信息
 * @Author:sunhuihong
 * @Date: 2022-05-23 14:43:52
 * @LastEditTime: 2024-06-14 10:51:49
-->
<template>
  <div class="view-hsvcmng-base-info">
    <el-row style="margin: 30px 0 60px 0; padding-top: 20px;" :gutter="0" type="flex" justify="space-between">
      <el-col :span="15">
        <el-form  ref="serviceCfg" :model="serviceCfg" :rules="rules" label-width="100px">
          <el-row>
            <el-col :span="12">
              <el-form-item label="所属机构:" prop="institutionId" v-if="mode !== 'add'">
                <el-select size="small" v-model="serviceCfg.institutionText" filterable :disabled="true"  
                  style="width: 240px;" placeholder="请输入/选择" >
                </el-select>
              </el-form-item>
              <el-form-item label="所属机构:" prop="institutionId" v-else>
                <el-select style="width:240px" size="small" v-model="serviceCfg.institutionId" @change="handleInstData" 
                  placeholder="请输入/选择" filterable clearable :disabled="readonly" 
                  :filter-method="interactionUtil.debounce((value) => commonUtil.handleListFilter(value, 'institutionList', srcInstitutionList, this))"
					        @visible-change="(visible) => 
                    commonUtil.handleListFilterVisibleChange(visible, 'institutionList', srcInstitutionList, this)">
                  <el-option v-for="item in institutionList" :key="item.id" :label="item.name" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="服务名称:" prop="name" >
                <el-input v-model.trim="serviceCfg.name" placeholder="请输入服务名称" style="width: 240px;" size="small" 
                  :disabled="readonly" :readonly="readonly">
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-form-item label="服务时间:" prop="timeRange">
              <el-col :span="12" >
                <el-time-picker style="width: 270px;" size="small" v-model="serviceCfg.timeRange" is-range 
                  placeholder="选择时间范围" range-separator="至" start-placeholder="选择开始时间" 
                  end-placeholder="选择结束时间" :readonly="readonly" :clearable="false"
                  format = 'HH:mm:ss' value-format = 'HH:mm:ss' :disabled="true" >
                </el-time-picker>
              </el-col>
              <el-col :span="12">
                <el-checkbox v-model="serviceCfg.isWholeDay" :disabled="true" 
                :true-label="1" :false-label="0">全天(24小时服务)</el-checkbox>
              </el-col>
            </el-form-item>
          </el-row>
          <el-row style="margin-top: 10px;">
            <el-form-item  label="服务类别:" prop="hserviceTypeCfgId" >
              <el-row v-if="mode == 'details'">
                 <el-checkbox v-model="isNurse" :label="serviceCfg.categoryText" :disabled="readonly"></el-checkbox>
                 <el-select v-model="serviceCfg.hserviceTypeCfgText" size="small" style="width: 158px;" 
                   :disabled="readonly">
                 </el-select>
              </el-row>
              <el-row v-for="(item, index) in hsvcTypeCfgDOList" :key="index" v-else>
                <el-radio-group v-model="serviceCfg.category" v-if="index == 0">
                  <el-radio :label="item.hsvcTypeCfgDOList[0].categoryType" style="margin-right: 0;" :disabled="readonly" >
                    {{item.hsvcTypeCfgDOList[0].categoryName}}
                    <el-select v-model="serviceCfg.hserviceTypeCfgId"   :disabled="readonly"  size="small" 
                      style="width: 158px; margin-left: 20px;">
                      <el-option  v-for="items in item.hsvcTypeCfgDOList[0].hserviceTypeCfgList" :key="items.id"  
                        :label="items.name" :value="items.id">
                      </el-option>
                    </el-select>
                  </el-radio>      
                </el-radio-group>
              </el-row>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="服务模式:" prop="mode">
              <el-radio-group v-model="serviceCfg.mode" :min="0" :max="1">
                <el-radio v-for="(value, key) in modeMap" :key="key" 
                  :label="parseInt(key)" :disabled="readonly">
                  {{value}}
                </el-radio>
              </el-radio-group>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item style="width: 100%;" label="服务简介:" prop="description">
              <el-input style="width: 100%;" v-model="serviceCfg.description" placeholder="请输入服务简介" 
                :disabled="readonly" :readonly="readonly" type="textarea" :rows="3"/>
            </el-form-item>
          </el-row>
          <el-row style="width: 100%;">
            <el-form-item label="服务宣传:" prop="slogan">
              <el-select v-model="serviceCfg.slogan" :disabled="readonly" size="small" style="width:100%;">
                <el-option v-for="(item,index) in sloganList" :key="index" :label="item.text" :value="item.text">
                </el-option>
              </el-select>
            </el-form-item>
          </el-row>
          <el-row >
            <el-form-item label="服务大图:" prop="svcImagePath" ref="validatorSvcImage">
		      		<el-upload v-if="mode != 'details'" ref="svcImagePath" drag accept="image/jpeg,image/png" action="" 
                :auto-upload="false" :show-file-list="false" :on-change="handleServiceChange" >
		      			<img v-if="!serviceFile && !serviceCfg.svcImagePath" style="margin-top: 46px; width: 40px; height: 40px" 
                  src="@/assets/common/img-common-chooseimg.png" alt="">
  		      		<div v-if="!serviceFile && !serviceCfg.svcImagePath" class="el-upload__text" style="font-size: 13px;">
                  将文件拖到此处 
                  <span style="line-height: 0.3">或 <em>点击上传</em></span>
                </div>
		      			<div v-else style="position: relative;">
                  <el-image style="width: 360px; height: 208px" :src="urlServiceLogo" fit="contain"></el-image>
                  <div class="change-img-hover">
                    <span style="color: #9EA6B4" >将文件拖到此处 或</span>
                    <span style="color: #2F54EB;">点击上传</span>
                  </div>
                </div>
                <div class="el-upload__tip" style="margin-left: 50px;" slot="tip">
                  <span>
                    请上传宽度不小于750像素的图片，图片大小不超过
                    <span class="tip-red">5M</span>，支持上传<span class="tip-red">png、jpg、jpeg</span>
                  </span>
                </div> 
		      		</el-upload>
		      		<el-image v-else style="width: 360px; height: 208px" :preview-src-list="previewImgList" 
                :src="urlServiceLogo" fit="contain">
              </el-image>
            </el-form-item>
          </el-row>
          <el-row >
            <el-form-item label="适用人群:" prop="suitableImagePath" ref="validatorSuitable">
		    			<el-upload v-if="mode != 'details'" ref="suitableImagePath" drag accept="image/jpeg,image/png" action="" 
                :auto-upload="false" :show-file-list="false" :on-change="handleCrowdChange">
		    				<img v-if="!userFile && !serviceCfg.suitableImagePath" style="margin-top: 46px; width: 40px; height: 40px" 
                  src="@/assets/common/img-common-chooseimg.png" alt="">
  		    			<div v-if="!userFile && !serviceCfg.suitableImagePath" class="el-upload__text" style="font-size: 13px;">
                  将文件拖到此处 <span style="line-height: 0.3">或 <em>点击上传</em></span>
                </div>
		      			<div v-else style="position: relative;">
                  <el-image style="width: 360px; height: 208px" :src="urlUserLogo" fit="contain"></el-image>
                  <div class="change-img-hover">
                    <span style="color: #9EA6B4;">将文件拖到此处 或</span>
                    <span style="color: #2F54EB;">点击上传</span>
                  </div>
                </div>
                <div class="el-upload__tip" style="margin-left: 50px;" slot="tip">
                  <span>
                    请上传宽度不小于600像素的图片，图片大小不超过
                    <span class="tip-red">5M</span>，支持上传<span class="tip-red">png、jpg、jpeg</span>
                  </span>
                </div> 
		        	</el-upload>
		        	<el-image v-else style="width: 360px; height: 208px" :preview-src-list="previewImgList" 
                :src="urlUserLogo" fit="contain">
              </el-image>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item style="width: 100%" label="适用人群:" prop="suitableGroup">
              <el-input style="width: 100%;" v-model="serviceCfg.suitableGroup" placeholder="请输入适用人群" 
                type="textarea" maxlength="500" :rows="4" :disabled="readonly" :readonly="readonly" />
            </el-form-item>
          </el-row>
        </el-form>
      </el-col>
      <el-col :span="7">
        <div style="height: 1100px; overflow-y: scroll; padding-right: 25px;">
          <img style="width: 100%;" src="@/assets/hsvccfg/app.png" alt="">
        </div>
      </el-col>
    </el-row>
    <div class="bk-wizard-bottons" style="padding-right: 25px;">
      <wizard-buttons :mode="mode" :status="btnStatus" @btnpressed="handleBtnSelection" />
    </div>
  </div>
</template>
<script>
import hserviseStore from './HserviceDetailStore.js';
import Constant from '@/global/Constant.js';

let BaseInfoPanel= {
  name: 'BaseInfoPanel',
  hserviseStore,
  
  data() { 
	  let validateDescription = (_rule, _value, callback) => {
	    if (this.serviceCfg.description && !this.serviceCfg.description.trim().length) {
				callback(new Error('服务简介不能输入全空格或全换行'));
			} else if (!this.serviceCfg.description) {
				callback(new Error('请填写服务简介'));
			} else {
        callback();
      }
    };

    let validateSuitableGroup = (_rule, _value, callback) => {
			if (this.serviceCfg.suitableGroup && !this.serviceCfg.suitableGroup.trim().length) {
				callback(new Error('适用人群不能全输入空格或者换行等空白字符'));
			} else {
				callback();
			}
    };

	  let validateSvcImage = (_rule, _value, callback) => {
	  	if (!this.urlServiceLogo || !this.urlServiceLogo.length) {
	  		callback(new Error('请上传服务图片'));
	  	} else {
	  		callback();
	  	}
    };

	  let validateSuitableImage = (_rule, _value, callback) => {
	  	if (!this.urlUserLogo || !this.urlUserLogo.length) {
	  		callback(new Error('请上传适用人群图片'));
	  	} else {
	  		callback();
	  	}
    };
    return {
      isNurse: true,
      btnStatus: {'prev': false, 'next': true, 'submit': false}, 
      rules: {
        institutionId: [
          {required: true, message: '请选择所属机构', trigger: 'change'},
        ],
        name: [
          {required: true, message: '请输入服务名称', trigger: 'blur'},
          {min: 1, max: 25, message: '长度在 1 到 25 个字符', trigger: 'change'}
        ],
        hserviceTypeCfgId: [
          {required: true, message: '请选择服务类别', trigger: ['blur','change']},
        ],
        mode: [
          {required: true, message: '请选择服务模式', trigger: ['blur','change']},
        ],
        slogan: [{required: true, message:'请选择服务宣传',trigger: 'change'}],
        description: [
          {required: true, validator: validateDescription, trigger: 'blur'},
          {max: 1000, message: '长度不能超过 1000 个字符', trigger: 'blur'}
        ],
			  svcImagePath: [{required: true, validator: validateSvcImage, trigger: 'blur'}],
        suitableImagePath: [{required: true, validator: validateSuitableImage, trigger: 'blur'}],
        suitableGroup: [{required: false, validator: validateSuitableGroup, trigger: 'blur'}],
      },
      institutionList: [],
    }
  },

  computed: {
    mode() {
      return hserviseStore.state.mode;
    },

    serviceCfgBaseInfoDO() {
      return hserviseStore.state.serviceCfgBaseInfoDO;
    },

    serviceCfg() {
      this.clearVaild();
      this.institutionList = hserviseStore.state.institutionList;
      let startTimeDate = this.dateUtil.dateTimeFormat('2016-09-10 ' + hserviseStore.state.serviceCfg.startTime);
      let endTimeDate = this.dateUtil.dateTimeFormat('2016-09-10 ' + hserviseStore.state.serviceCfg.endTime);
      hserviseStore.state.serviceCfg.timeRange = [startTimeDate,endTimeDate];
      return hserviseStore.state.serviceCfg;
    },

    urlUserLogo() {
      if (hserviseStore.state.userFile) {
        return this.commonUtil.file2Url(hserviseStore.state.userFile);
      } else if (hserviseStore.state.serviceCfg.suitableImagePath) {
        return this.commonUtil.fillUrlArgments(this.commonUrl.URL_DOWNLOAD_FILE, this.serviceCfg.suitableImagePath);
      } else {
        return '';
      }
    },

	  userFile() {
      return hserviseStore.state.userFile ? hserviseStore.state.userFile : null;
    },

    urlServiceLogo() {
      if (hserviseStore.state.serviceFile) {
        return this.commonUtil.file2Url(hserviseStore.state.serviceFile);
      } else if (this.serviceCfg.svcImagePath) {
        return this.commonUtil.fillUrlArgments(this.commonUrl.URL_DOWNLOAD_FILE, this.serviceCfg.svcImagePath);
      } else {
        return '';
      }
    },

    serviceFile() {
      return hserviseStore.state.serviceFile ? hserviseStore.state.serviceFile : null;
    },

    modeMap() {
      return hserviseStore.state.modeMap;
    },

    srcInstitutionList() {
      return hserviseStore.state.institutionList;
    },

    hsvcTypeCfgDOList() {
      return hserviseStore.state.svcTypeCfgDOList;
    },

    sloganList() {
      return hserviseStore.state.sloganList;
    },

    readonly() {
      return hserviseStore.state.mode == 'details';
    },

    previewImgList() {
      let imgList = [];
      if (this.serviceCfg.svcImagePath) {
        imgList.push(this.commonUtil.fillUrlArgments(this.commonUrl.URL_DOWNLOAD_FILE, this.serviceCfg.svcImagePath));
      }
      if (this.serviceCfg.suitableImagePath) {
        imgList.push(this.commonUtil.fillUrlArgments(this.commonUrl.URL_DOWNLOAD_FILE, this.serviceCfg.suitableImagePath));
      }
      return imgList;
    }
  },

  methods: {
    //获取指定机构的数据
    getHsvcTypeData(institutionId) {
      let params = {'institutionId': institutionId};
			let header = this.encryptionUtil.signatureParams(params,
				Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
      let requestData = {
        method: 'GET', 
        url: Constant.URL_GET_LIST_OPENING_HSERVICE,
        param: params,
        header: header,
        contentType: this.commonConst.CNTYPE_URLENCODED
      };
      this.vueRequest(requestData).then(result => {
        if(result != null){
          hserviseStore.commit("changeSvcTypeCfgDOList", result.data);
        }
      });
    },

    //选择机构后获取对应的数据
    handleInstData(instId) {
      this.getHsvcTypeData(instId);
    },

    //改变服务大图
    handleServiceChange(file, _fileList) {
      let limitation = {
        maxSize: Constant.LIMIT_IMG_SIZE_5,
        maxWidth: 750.0,
        maxHeight: 0,
        extLimit: {
          limitType: 1,
          minRatio: 0.1,
          minRatioText: '100:10',
          maxRatio: 1.0,
          maxRatioText: '100:100'
        },
        returnData:{}
      };
      this.imgUtil.validateAndCompressImg(file, limitation).then((data) => {
        if (data.errorText && data.errorText.length) {
          this.$message.error(data.errorText);
        } else {
          hserviseStore.commit('changeServiceFile', file);
        }
        this.$refs['validatorSvcImage'].clearValidate();
      })
    },

    //改变适用人群图片
    handleCrowdChange(file, _fileList) {
      let limitation = {
        maxSize: Constant.LIMIT_IMG_SIZE_5,
        maxWidth: 600.0,
        maxHeight: 0,
        extLimit: {
          limitType: 1,
          minRatio: 0.1,
          minRatioText: '100:10',
          maxRatio: 0.8,
          maxRatioText: '100:80'
        },
        returnData:{}
      };
      this.imgUtil.validateAndCompressImg(file, limitation).then((data) => {
        if (data.errorText && data.errorText.length) {
          this.$message.error(data.errorText);
        } else {
          hserviseStore.commit('changeUserFile', file);
        }
        this.$refs['validatorSuitable'].clearValidate();
      })
    },

    handleBtnSelection(opr) {
      if (this.mode == 'details' || opr != 'next')  {
        this.$emit("panel-operate", opr);
        return true;
      }
      this.$refs.serviceCfg.validate((valid) => {
        if (!valid) return;
        this.$emit("panel-operate", opr);
      })        
    },
    
    clearVaild() {
    	this.$nextTick(() => {
        this.$refs["serviceCfg"].clearValidate();
      });
		},
  },

  destroyed() {
    //销毁的时候同步数据
    hserviseStore.commit('changeServiceCfgBaseInfoDO', this.serviceCfgBaseInfoDO);
    hserviseStore.commit('changeServiceCfg', this.serviceCfg);
  },
}
export default BaseInfoPanel
</script>
<style >
.view-hsvcmng-base-info .el-upload-dragger {
  overflow: visible;
  height: 208px;
}

.view-hsvcmng-base-info .el-upload:hover .change-img-hover {
  display: block;
}

.view-hsvcmng-base-info .change-img-hover {
  position: absolute;
  top: 105px;
  left: 95px;
	display: none;
  font-size: 13px;
  text-align: center;
  z-index: 200;
}

.view-hsvcmng-base-info .tip-red {
  color: #FF1515;
}

.view-hsvcmng-base-info .el-upload__tip {
  width: 276px;
  display: flex;
  flex-direction: column;
  align-items: center;
  line-height: 18px;
  color: #999999;
}

</style>





// WEBPACK FOOTER //
// src/components/hsvcmng/components/hservicedetails/BaseInfoPanel.vue